import { render, staticRenderFns } from "./RetailerView.vue?vue&type=template&id=28dbc6e6"
import script from "./RetailerView.vue?vue&type=script&lang=js"
export * from "./RetailerView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports